import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import { getIprsConfigs, getIprsConfigRaw, publishIprsConfig, createIprsConfig } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getIprsConfigsWatcher() {
  while (true) {
    const { payload: partner } = yield take(types.GET_IPRS_CONFIGS_REQUEST);
    try {
      const response = yield call(getIprsConfigs, partner);
      yield put(actions.getIprsConfigsSuccess(response.data.data));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getIprsConfigsFail(e.response ? e.response.data : {}));
    }
  }
}

export function* getIprsConfigRawWatcher() {
  while (true) {
    const { payload: { partner, type } } = yield take(types.GET_IPRS_CONFIG_RAW_REQUEST);
    try {
      const response = yield call(getIprsConfigRaw, partner, type);
      yield put(actions.getIprsConfigRawSuccess(response.data.data.yaml));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getIprsConfigRawFail(e.response ? e.response.data : {}));
    }
  }
}

export function* publishIprsConfigWatcher() {
  while (true) {
    const { payload: { partner, type, rawYaml } } = yield take(types.PUBLISH_IPRS_CONFIG_REQUEST);
    try {
      const response = yield call(publishIprsConfig, partner, type, rawYaml);
      yield put(actions.publishIprsConfigSuccess(response.data));
      yield put(actions.getIprsConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.publishIprsConfigFail(e.response ? e.response.data : {}));
    }
  }
}

export function* createIprsConfigWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.CREATE_IPRS_CONFIG_REQUEST);
    try {
      const response = yield call(createIprsConfig, partner, rawYaml);
      yield put(actions.createIprsConfigSuccess(response.data));
      yield put(actions.getIprsConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.createIprsConfigFail(e.response ? e.response.data : {}));
    }
  }
}
